import {css, cx as addStyles} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {Button} from './Button';
import {theme} from './Common';
import {Modal} from './Modal';
import {OptionProps, Select} from './Select';
import {TextInput} from './TextInput';

type CustomerPortalCheckFormModalProps = {
  isOpen: boolean;
  setModal: () => unknown;
  inputs: {
    name: string;
    setName: (name: string) => unknown;
    address: string;
    setAddress: (address: string) => unknown;
    addressLine2: string;
    setAddressLine2: (addressLine2: string) => unknown;
    city: string;
    setCity: (city: string) => unknown;
    state: string;
    setState: (state: string) => unknown;
    zipcode: string;
    setZipcode: (zipcode: string) => unknown;
  };
  states: OptionProps<string>[];
  onClickNext: () => unknown;
};

export const CustomerPortalCheckFormModal = ({
  isOpen,
  setModal,
  inputs: {
    name,
    setName,
    address,
    setAddress,
    addressLine2,
    setAddressLine2,
    city,
    setCity,
    state,
    setState,
    zipcode,
    setZipcode,
  },
  states,
  onClickNext,
}: CustomerPortalCheckFormModalProps) => {
  return (
    <Modal title='Check Details' isOpen={isOpen} setModal={setModal}>
      <CheckModalContent>
        <TextInput
          type='text'
          placeholder='Full Name (Recipient)'
          value={name}
          setValue={setName}
          maxLength={40}
          {...inputStyle}
        />
        <TextInput
          type='text'
          placeholder='Address'
          value={address}
          setValue={setAddress}
          {...inputStyle}
        />
        <TextInput
          type='text'
          placeholder='Address Line 2'
          value={addressLine2}
          setValue={setAddressLine2}
          {...inputStyle}
        />
        <CheckModalDownsideContainer>
          <TextInput
            type='text'
            placeholder='City'
            value={city}
            setValue={setCity}
            containerClassName={inputStyle.containerClassName}
            className={css({marginLeft: 0, [theme.mediaMaxWidth.small]: {marginRight: 0}})}
          />
          <Select
            options={states}
            value={state}
            onChange={setState}
            placeholder='State'
            containerClassName={selectInputStyle}
          />
          <TextInput
            type='text'
            placeholder='Zipcode'
            mask='zipcode'
            value={zipcode}
            setValue={setZipcode}
            containerClassName={inputStyle.containerClassName}
            className={css({marginRight: 0, [theme.mediaMaxWidth.small]: {marginLeft: 0}})}
          />
        </CheckModalDownsideContainer>
        <Button buttonStyle='primary' onClick={onClickNext}>
          Next
        </Button>
      </CheckModalContent>
    </Modal>
  );
};
const containerBase = css({display: 'flex', alignItems: 'center'});
const CheckModalContent = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={addStyles(containerBase, css({flexDirection: 'column', justifyContent: 'center'}))}
    {...args}
  />
);
const CheckModalDownsideContainer = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={addStyles(
      containerBase,
      css({
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: theme.spacings.xsmall,
        [theme.mediaMaxWidth.small]: {flexDirection: 'column', div: {margin: '8px 0'}},
      }),
    )}
    {...args}
  />
);
const inputStyle = {
  containerClassName: css({width: '100%', [theme.mediaMaxWidth.small]: {margin: 0}}),
  className: css({margin: `${theme.spacings.xxsmall} 0px`}),
};
const selectInputStyle = css({
  width: '200px',
  height: '53px',
  [theme.mediaMaxWidth.small]: {width: '100%'},
});
